import type { Document } from '#shared/types/document'
import type { UseSeoMetaInput } from '@unhead/vue'

export function useDocumentSeo(
  { seo, cover, title }: Document,
  extra?: UseSeoMetaInput,
) {
  const ogTitle = seo?.ogTitle || seo?.title || title
  const ogDescription = seo?.ogDescription
  const ogImage = cover?.url

  useSeoMeta({
    title: seo?.title || title,
    ogTitle,
    description: seo?.description,
    ogDescription,
    ogImage,
    twitterTitle: ogTitle,
    twitterDescription: ogDescription,
    twitterImage: ogImage,
    twitterImageAlt: cover?.altText,
    ...extra,
  })
}
